<template>
    <div class="tag padding-horizontal-tiny padding-vertical-xtiny regular" :class="[successClasses, dangerClasses, neutralClasses, defaultClasses]">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'BTag',
    props: {
        success: Boolean,
        danger: Boolean,
        neutral: Boolean
    },
    computed: {
        successClasses() {
            return this.success ? 'bg-green-base white-base' : '';
        },
        dangerClasses() {
            return this.danger ? 'bg-red-base white-base' : '';
        },
        neutralClasses() {
            return this.neutral ? 'bg-white-darker-3 ink-lighter-1': '';
        },
        defaultClasses() {
            return !this.success && !this.danger && !this.neutral ? 'bg-blue-base white-base' : '';
        }
    }
}
</script>

<style scoped lang="scss">
    .tag {
        font-size: 1rem;
        display: inline-block;
        border-radius: 5px;
    }
</style>

<docs>
    Tag
</docs>